import { graphql } from "relay-runtime"

export const chDeleteMedicalReportMutation = graphql`
  mutation chDeleteMedicalReportMutation($input: Ch_deleteMedicalReportAttachmentInput!, $connections: [ID!]!) {
    deleteMedicalReport: ch_deleteMedicalReportAttachment(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      medicalReportAttachment {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
